<template>
  <span class="location-search-results__heading">
    {{ count }} Locations Found
  </span>
</template>

<script>
  export default {
    props: {
      count: {
        required: true,
        type: Number
      }
    }
  };
</script>
